import React, { FC } from 'react'
import classNames from 'classnames'
import { ContextNotification } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { PendingOperationCard } from './PendingOperationCard/PendingOperationCard'

import { useAPIGetPendingOperations } from 'api/apiHooks/useAPIGetPendingOperations'
import { useAPIGetUserPermissions } from 'api/apiHooks/useUserPermissions'
import { useAPIGetUserMetadata } from 'api/apiHooks/useAPIGetUserMetadata'

interface PendingOperationsProps {
  className?: string
}

export const PendingOperations: FC<PendingOperationsProps> = ({
  className,
}) => {
  const { t } = useTranslation(['frontPage'])
  const { data: operations, isError } = useAPIGetPendingOperations()
  const { data: userMetadata } = useAPIGetUserMetadata()

  // A user that has been marked as strongly authenticated by hand in Kenno has
  // no identity from Telia in Cognito, so confirming is not possible before the
  // user has identified themselves.
  const { data: permissions } = useAPIGetUserPermissions()

  if (isError) {
    return (
      <div className={classNames('phone:px-4 max-tablet:my-4', className)}>
        <ContextNotification type="error" rounded="m">
          {t('frontPage:pendingOperations.error')}
        </ContextNotification>
      </div>
    )
  }

  if (!operations || operations.length === 0) {
    return null
  }

  return (
    <div
      className={classNames('phone:px-4 max-tablet:my-4', className)}
      aria-live="polite"
    >
      <div className="flex flex-col tablet:flex-row flex-wrap gap-2">
        {operations.map((operation) => (
          <PendingOperationCard
            key={operation.nonce}
            operation={operation}
            isImpersonator={userMetadata?.isImpersonator ?? false}
            identificationRequired={
              permissions?.identificationRequired ?? false
            }
          />
        ))}
      </div>
    </div>
  )
}
